import React from 'react';
import { motion } from 'framer-motion';
import Section from '../../shared/reusables/Section';

const fadeIn = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
};

const languageColors = {
    JavaScript: '#f7df1e',
    Python: '#3776AB',
    Java: '#007396',
    CSharp: '#68217A',
    PHP: '#4F5B93',
    Ruby: '#CC342D',
    Go: '#00ADD8',
    Swift: '#F05138',
    TypeScript: '#007ACC',
    Kotlin: '#F18E33',
};

const GitHubProjectsSection = ({ projects }) => {
    return (
        <Section title="GitHub Projects">
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {projects.map((project, index) => (
                    <motion.div
                        key={index}
                        initial="hidden"
                        whileInView="visible"
                        variants={fadeIn}
                        transition={{ duration: 0.5 }}
                        style={{
                            background: 'var(--surface-2)',
                            border: '1px solid var(--border)',
                            borderRadius: '12px',
                            padding: '16px 20px',
                            boxSizing: 'border-box',
                            overflow: 'hidden',
                            transition: 'border-color 0.2s',
                        }}
                        onMouseEnter={e => e.currentTarget.style.borderColor = 'var(--accent)'}
                        onMouseLeave={e => e.currentTarget.style.borderColor = 'var(--border)'}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '8px', marginBottom: '6px' }}>
                            <a
                                href={project.html_url}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    textDecoration: 'none',
                                    color: 'var(--text)',
                                    fontFamily: 'var(--font-display)',
                                    fontWeight: 700,
                                    fontSize: '1rem',
                                }}
                            >
                                {project.name}
                            </a>
                            {project.language && (
                                <span style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    padding: '3px 10px',
                                    background: 'rgba(108,99,255,0.12)',
                                    border: '1px solid rgba(108,99,255,0.25)',
                                    borderRadius: '999px',
                                    fontSize: '0.78rem',
                                    color: 'var(--accent)',
                                    fontWeight: 500,
                                }}>
                                    <span style={{
                                        width: '8px',
                                        height: '8px',
                                        borderRadius: '50%',
                                        background: languageColors[project.language] || 'var(--accent)',
                                        flexShrink: 0,
                                    }} />
                                    {project.language}
                                </span>
                            )}
                        </div>
                        <p style={{
                            color: 'var(--text-muted)',
                            fontSize: '0.88rem',
                            margin: '0 0 10px',
                            lineHeight: 1.5,
                        }}>
                            {project.description || 'No description available.'}
                        </p>
                        <a
                            href={project.html_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                color: 'var(--accent)',
                                fontSize: '0.82rem',
                                fontWeight: 500,
                                textDecoration: 'none',
                            }}
                        >
                            View on GitHub →
                        </a>
                    </motion.div>
                ))}
            </div>
        </Section>
    );
};

export default GitHubProjectsSection;
